import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import {
  extractFileName,
  getMonthName,
  numberToText,
} from '../../../utils/helpers';
import { SolicitudeService } from '../../services/solicitude.service';

@Component({
  selector: 'app-update-state-modal',
  templateUrl: './update-state-modal.component.html',
  styleUrl: './update-state-modal.component.scss',
  providers: [DialogService],
})
export class UpdateStateModalComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() dataToView: any | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() updateStateComplete = new EventEmitter<void>();

  showButtons: boolean = true;
  showConfirmation: boolean = true;
  showTextarea: boolean = true;
  primaryButtonLabel: string = 'PENDIENTE DE FIRMA';
  userData: any = null;

  steps = [
    { label: 'Recibido', key: 1 },
    { label: 'En evaluación', key: 2 },
    { label: 'Aprobado', key: 3 },
    { label: '', key: 4 },
  ];

  get visibleSteps() {
    if (this.status === 'aprobado') {
      return this.steps.slice(0, 4); // Muestra solo los primeros 3 labels
    }
    if (this.status === 'rechazado') {
      return this.steps.slice(0, 4);
      // return [
      //   this.steps[0], // Recibido
      //   this.steps[1], // En evaluación
      //   { label: 'Rechazado', key: 4 }, // Rechazado
      // ];
    }
    return this.steps;
  }

  currentStep = 1;
  status: 'pendiente' | 'aprobado' | 'rechazado' = 'pendiente';

  solicitude = {
    stateSolicitudeId: 1,
    stateSolicitudeName: 'En evaluación',
  };

  isLoading: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  dateStart: Date = new Date();
  dateEnd: Date = new Date();
  collaborator: string = '';
  typeVacationName: string = '';
  adminMessage: string = '';
  collaboratorMessage: string = '';
  confirmationChecked = false;
  downloadUrl: string | null = null;
  typeVacationId: any;
  selectedFileName: string | null = null;
  selectedFileUploadName: string | null = null;
  documentGenerated: boolean = false;
  documentUpload: boolean = false;
  totalDays: number = 0;
  currentFile: File | null = null;

  @ViewChild('pdfUploader') pdfUploader: any;

  constructor(
    private solicitudeService: SolicitudeService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }
  }
  ngOnChanges(): void {
    // console.log('this.dataToView', this.dataToView);

    if (!this.dataToView || !this.dataToView.detailSolicitudId) {
      this.isLoading = false;
      return;
    }
    this.isLoading = true;

    this.solicitudeService
      .getDetailSolicitudeByDetailSolicitudeId(
        this.dataToView.detailSolicitudId
      )
      .subscribe({
        next: (solicitude: any) => {
          // console.log(
          //   'solicitude.stateSolicitudeId',
          //   solicitude.stateSolicitudeId
          // );

          this.solicitude = {
            stateSolicitudeId: solicitude.stateSolicitudeId,
            stateSolicitudeName: solicitude.stateSolicitudeName,
          };
          console.log(
            'solicitude.stateSolicitudeId',
            solicitude.stateSolicitudeId
          );

          this.updateState(solicitude.stateSolicitudeId);
          this.dateStart = solicitude.breakStartDate;
          this.dateEnd = solicitude.breakEndDate;
          this.collaborator = solicitude.employeeName;
          this.adminMessage = solicitude.detailMessageAdmin || '';
          this.collaboratorMessage = solicitude.detailMessageCollaborator || '';
          this.typeVacationId = solicitude.typeVacationId;
          this.typeVacationName = solicitude.typeVacationName;
          if (solicitude.solicitudeUrl) {
            this.documentGenerated = true;
            this.documentUpload = true;
            this.downloadUrl = solicitude.solicitudeUrl;
            this.selectedFileName = extractFileName(solicitude.solicitudeUrl);
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          console.error(
            'Error al obtener los detalles del recibo de pago:',
            err
          );
        },
      });
  }

  updateState(stateId: number): void {
    switch (stateId) {
      case 1: // Recibido
        this.currentStep = 1;
        this.status = 'pendiente';
        this.primaryButtonLabel = 'FIRMAR';
        // this.showButtons = false;
        this.showButtons = true;
        this.showConfirmation = true;
        this.showTextarea = true;
        break;
      case 2: // En evaluación
        this.currentStep = 2;
        this.status = 'pendiente';
        this.primaryButtonLabel = 'FIRMAR';
        this.showButtons = true;
        this.showConfirmation = true;
        this.showTextarea = true;
        break;
      case 3: // Aprobado
      case 4: // Rechazado
        this.currentStep = stateId === 3 ? 4 : 3;
        this.status = stateId === 3 ? 'aprobado' : 'rechazado';
        this.showButtons = false;
        this.showConfirmation = false;
        this.showTextarea = false;
        break;
      default:
        console.warn('Estado no manejado:', stateId);
    }
  }

  parseCustomDate(dateString: string): Date {
    const [day, month, year] = dateString.split('/').map(Number);
    const fullYear = year < 100 ? 2000 + year : year;
    return new Date(fullYear, month - 1, day);
  }

  validateForm(isApproval: boolean = true): boolean {
    const isInvalid = !this.confirmationChecked;

    if (isApproval && !this.currentFile) {
      return true;
    }

    return isInvalid;
  }

  onButtonClick() {
    this.closeDialog();
  }

  resetForm() {
    // this.collaboratorMessage = '';
    this.confirmationChecked = false;
    this.currentFile = null;
  }

  onPrimaryButtonClick(): void {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const stateId = 2;
    const title = '¡Firmado!';

    const request: any = {
      solicitudeId: this.dataToView.solicitudId,
      stateSolicitudeId: stateId,
      userAdminId: this.userData.employeeId,
      detailMessageAdmin: this.adminMessage,
      detailMessageCollaborator: this.collaboratorMessage,
      typeVacationId: this.typeVacationId,
      // solicitudeUrl: this.downloadUrl!,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    if (this.currentFile) {
      console.log('this.currentFile', this.currentFile);

      formData.append('file', this.currentFile);
    }

    this.solicitudeService.postUpdateStateSolicitudes(formData).subscribe({
      next: (response) => {
        loadingRef.close();
        this.solicitude.stateSolicitudeId = stateId;

        // const successMessage = response.message;
        const ref = this.dialogService.open(ModalSuccessComponent, {
          closable: true,
          header: '',
          data: {
            text: 'Actualizado correctamente',
            title: title,
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.resetForm();
        this.updateStateComplete.emit();
        this.closeDialog();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          closable: true,
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.resetForm();
        console.error('Error al actualizar la solicitud:', err);
      },
    });
  }

  onRejectClick(): void {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      header: 'Cargando',
      closable: false,
    });

    const request: any = {
      solicitudeId: this.dataToView.solicitudId,
      stateSolicitudeId: 4,
      userAdminId: this.userData.employeeId,
      detailMessageAdmin: this.adminMessage,
      detailMessageCollaborator: this.collaboratorMessage,
      typeVacationId: this.typeVacationId,
      solicitudeUrl: this.downloadUrl!,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    this.solicitudeService.postUpdateStateSolicitudes(formData).subscribe({
      next: (response) => {
        loadingRef.close();
        const successMessage = response.message;
        const ref = this.dialogService.open(ModalSuccessComponent, {
          closable: false,
          data: {
            text: successMessage,
            title: '¡Rechazado!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.resetForm();
        this.updateStateComplete.emit();
        this.closeDialog();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.resetForm();
        console.error('Error al rechazar la solicitud:', err);
      },
    });
  }

  onDragOver(event: DragEvent) {
    if (!this.documentUpload) return;

    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'copy';
  }

  onDragLeave(event: DragEvent) {
    if (!this.documentUpload) return;

    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    if (!this.documentUpload) return;

    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0];

      if (this.isValidFile(droppedFile)) {
        this.currentFile = droppedFile;
        this.selectedFileUploadName = droppedFile.name;
        console.log('this.selectedFileUploadName', this.selectedFileUploadName);

        this.validateForm();
      } else {
        this.currentFile = null;
        this.selectedFileUploadName = null;
        this.validateForm();

        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF, DOC o DOCX de hasta 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
      }
    }
  }

  isValidFile(file: File): boolean {
    const allowedExtensions = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
    const maxSize = 10 * 1024 * 1024;

    if (!allowedExtensions.includes(file.type)) {
      console.log('Tipo de archivo no permitido:', file.type);
      return false;
    }

    if (file.size > maxSize) {
      console.log('Archivo demasiado grande:', file.size);
      return false;
    }

    return true;
  }

  onChangeFile(event: any) {
    const selectedFile = event.files[0];
    if (selectedFile) {
      const maxSize = 10 * 1024 * 1024;
      const allowedTypes = ['application/pdf'];

      if (!allowedTypes.includes(selectedFile.type)) {
        this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        return;
      }

      if (selectedFile.size > maxSize) {
        this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo es demasiado grande. El tamaño máximo permitido es de 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        return;
      }

      this.currentFile = selectedFile;
      this.selectedFileUploadName = selectedFile.name;
      this.validateForm();
    }
  }

  openFileUpload(type: string) {
    if (!this.documentUpload) return;

    if (type === 'pdf' && this.pdfUploader) {
      this.pdfUploader.choose();
    } else {
      console.error('El fileUploader no está disponible.');
    }
  }

  // Generar PDF
  onDownload() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const formattedDates = this.getFormattedDates();

    const request = {
      companyId: this.userData?.companyId,
      employeeId: this.userData?.employeeId,
      days: this.totalDays,
      daysName: numberToText(this.totalDays),
      dayStartDate: formattedDates?.startDate.day,
      monthNameStartDate: formattedDates?.startDate.month,
      yearStartDate: formattedDates?.startDate.year,
      dayEndDate: formattedDates?.endDate.day,
      monthNameEndDate: formattedDates?.endDate.month,
      yearEndDate: formattedDates?.endDate.year,
    };

    this.solicitudeService.postGeneratePDF(request).subscribe({
      next: (response) => {
        loadingRef.close();
        this.downloadUrl = response.solicitudePdfUrl;
        this.documentGenerated = true;
        this.documentUpload = true;
        this.selectedFileName = extractFileName(response.solicitudePdfUrl);
        const ref = this.dialogService.open(ModalSuccessComponent, {
          header: '',
          data: {
            text: 'El documento se ha generado con éxito.',
            title: '¡Éxito!',
            icon: 'pi pi-check-circle',
            showButton: true,
            buttonText: 'Revisar documento',
            buttonAction: () => this.downloadFile(),
          },
        });
        this.validateForm();
      },
      error: (err) => {
        loadingRef.close();
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          closable: true,
          data: {
            text:
              err.error?.error ||
              'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
            title: '¡Lo sentimos!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.validateForm();
        console.error('Error al generar pdf:', err);
      },
    });
    // this.closeDialog();
  }

  // Descargar PDF
  downloadFile() {
    if (!this.downloadUrl) return;

    const link = document.createElement('a');
    link.href = this.downloadUrl;
    link.target = '_blank';
    link.download = this.downloadUrl.split('/').pop() || 'documento.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  resetDocumentState() {
    this.documentGenerated = false;
    this.downloadUrl = null;
    this.currentFile = null;
    this.selectedFileName = null;
  }

  // Formateando fechas
  getFormattedDates() {
    if (!this.startDate || !this.endDate) return null;

    const startDay = this.startDate.getDate();
    const startMonth = this.startDate.getMonth() + 1;
    const startYear = this.startDate.getFullYear();

    const endDay = this.endDate.getDate();
    const endMonth = this.endDate.getMonth() + 1;
    const endYear = this.endDate.getFullYear();

    return {
      startDate: {
        day: startDay,
        month: getMonthName(startMonth),
        year: startYear,
      },
      endDate: {
        day: endDay,
        month: getMonthName(endMonth),
        year: endYear,
      },
    };
  }
}
